export enum AlertType {
    ALTRUJA_DEFAULT = 'alert',
    FIN_API_DEFAULT = 'fin-api-default',
    ALTRUJA_UNAUTHORIZED = 'altruja-unauthorized',
}

export interface Alert {
    /**
     * The unique identifier of the alert
     */
    _id: string;
    /**
     * The message of the alert
     */
    message: string;
    /**
     * The type of the alert
     */
    type: AlertType;
    /**
     * Whether the alert is hidden
     */
    hide: boolean;
    /**
     * The company of the alert
     */
    company: string;
    /**
     * The creation timestamp when this alert was created
     */
    createdAt: Date;
    /**
     * The timestamp when this alert was last updated
     */
    updatedAt: Date;
}
